import React from "react";
import { OptimizedGantt } from "@planzone/dto";
import { DateTime } from "luxon";
import { Context } from "@scenes/workloads/context";
import { isDone, isTask } from "../utils";
import { getDate } from "../utils/getDate";
import { Props } from "./types";
import styles from "./styles.scss";

function getDerivation(
  element: OptimizedGantt[number],
  completionDate: DateTime,
  userTimezone: string,
): number {
  const endDt = getDate(element.endDate, userTimezone);
  return completionDate.startOf("day").diff(endDt, "days").days;
}

function Derivation({ element, isDisabled, children }: Props) {
  const userTimezone = DateTime.local().zoneName;
  const { cell, areDerivationsToggled } = React.useContext(Context);
  const canPrintDerivation =
    isDone(element) && !!element.completionDate && isTask(element);
  const derivation = canPrintDerivation
    ? getDerivation(
        element,
        DateTime.fromISO(element.completionDate, { zone: "utc" }).setZone(
          userTimezone,
        ),
        userTimezone,
      )
    : 0;
  const hasDerivation = derivation > 0;

  return (
    <div className={styles.derivation}>
      {children(derivation)}
      {canPrintDerivation && hasDerivation && (
        <div
          className={styles.indicator}
          style={{
            width:
              isDisabled || !areDerivationsToggled
                ? 0
                : cell.width * derivation,
          }}
        />
      )}
    </div>
  );
}

export { Derivation };
